// Helpers for the multi-role employee model.
//
// `employeeRoleName` is the PRIMARY role (single string, always required).
// `employeeOtherPosition` is the SECONDARY roles list (string[], may be empty).
//
// Shift rotation only ever consults the primary role — secondaries are for
// org chart, role counts, profile display, and contact directories.
// Everything that previously did `emp.employeeRoleName === role.name` should
// instead call `employeeHasRole(emp, role.name)` so secondaries are honoured.

const norm = (v) => (typeof v === "string" ? v.trim() : "");

export const getAllEmployeeRoles = (employee) => {
  const primary = norm(employee?.employeeRoleName);
  const others = Array.isArray(employee?.employeeOtherPosition)
    ? employee.employeeOtherPosition.map(norm).filter(Boolean)
    : [];
  const all = primary ? [primary, ...others] : others;
  // de-dup case-sensitively but preserve order; primary always wins position 0
  const seen = new Set();
  return all.filter((r) => {
    if (seen.has(r)) return false;
    seen.add(r);
    return true;
  });
};

export const employeeHasRole = (employee, roleName) => {
  const target = norm(roleName);
  if (!target) return false;
  return getAllEmployeeRoles(employee).some(
    (r) => r.toLowerCase() === target.toLowerCase()
  );
};

export const getSecondaryRoles = (employee) =>
  Array.isArray(employee?.employeeOtherPosition)
    ? employee.employeeOtherPosition.map(norm).filter(Boolean)
    : [];

export const formatEmployeeRoles = (employee, { separator = ", " } = {}) =>
  getAllEmployeeRoles(employee).join(separator);
